import type { FaqItem } from './schema'

interface Props {
  items: FaqItem[]
  heading: string
}

export function ToolFaq({ items, heading }: Props) {
  if (items.length === 0) return null
  return (
    <section className="mt-12" aria-labelledby="tool-faq-heading">
      <h2
        id="tool-faq-heading"
        className="mb-6 text-2xl font-semibold tracking-tight text-foreground"
      >
        {heading}
      </h2>
      <dl className="space-y-6">
        {items.map((item, i) => (
          <div key={i} className="border-l-2 border-border pl-4">
            <dt className="text-base font-semibold text-foreground">{item.q}</dt>
            <dd className="mt-2 text-sm text-foreground/90">{item.a}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
